export default __webpack_public_path__ + "static/media/SIW610_T075_W0.46bf767c.webp";